import { FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IOSSwitch from 'src/features/shared/components/ui/ios-switch';

const FavouriteSwitchComponent: React.FC<any> = ({ client, updateClient }: any) => {
    const { t } = useTranslation();
    const updateFavLocker = (e: any) => {
        const newClientData = {
            ...client!,
            favouriteLockerEnabled: e.target.checked,
        };

        updateClient(newClientData, t('favLockerChanged'));
    };
    return (
        <FormControlLabel
            sx={{ mt: 1, mb: 3 }}
            control={
                <IOSSwitch
                    sx={{ mr: 2 }}
                    checked={client.favouriteLockerEnabled}
                    onChange={updateFavLocker}
                />
            }
            label={t('favouriteLockerEnabled')}
        />
    );
};

export default FavouriteSwitchComponent;
